package com.trevorwiebe.timesheet.loads.presentation.driver

sealed interface DriverLoadsEvent {
    data object OnRetry : DriverLoadsEvent

    // The driver's scanned documents on a load, identified by their PDF url.
    data class OnOpenDocument(val loadId: String, val documentUrl: String) : DriverLoadsEvent
    data class OnScanDocument(val loadId: String, val pages: List<ByteArray>) : DriverLoadsEvent
    data class OnDeleteDocument(val loadId: String, val documentUrl: String) : DriverLoadsEvent
}
